import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateConstants } from '@app/constants/date-constants';
import { Quote, QuoteState } from '@app/quoting/models/quote';
import { quoteSelector } from '@app/state/app.selectors';
import { AppState } from '@app/state/app.state';
import { Store } from '@ngrx/store';
import { selectQuote } from '@quoting/state/selectors/quoting-module.selectors';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-quote-note',
  templateUrl: './quote-note.component.html',
  styleUrls: ['./quote-note.component.scss'],
})
export class QuoteNoteComponent implements OnInit, OnDestroy {
  public quote: Quote;
  public quoteStateType = QuoteState;
  public dateFormat = DateConstants.LOCALE_FORMAT_SHORT();

  public noteTitle: string;
  public noteContent: string;
  selectQuoteSubscription$: Subscription;
  selectQuote$: Subscription;

  constructor(private state: Store<AppState>) {}

  ngOnDestroy(): void {
    this.selectQuoteSubscription$?.unsubscribe();
    this.selectQuote$?.unsubscribe();
  }

  ngOnInit(): void {
    const datePipe = new DatePipe('en-GB');
    this.selectQuoteSubscription$ = this.state.select(quoteSelector).subscribe((s) => {
      if (s.quote) {
        this.quote = s.quote;

        const offerWithNote = s.quote.approvalNote;
        if (offerWithNote) {
          this.noteTitle =
            s.quote.quoteState !== QuoteState.REQUEST_REJECTED && s.quote.quoteState !== QuoteState.OFFER_REJECTED
              ? `Your Quote Request Was Accepted on ${datePipe.transform(offerWithNote.resolvedDateTime, this.dateFormat)} by ${
                  offerWithNote.resolvedBy
                }`
              : `Your Quote Request Was Rejected on ${datePipe.transform(offerWithNote.resolvedDateTime, this.dateFormat)} by ${
                  offerWithNote.resolvedBy
                }`;

          this.noteContent = offerWithNote.note;
        }
      }
    });
  }
}
